import { Fetch } from '../helpers/fetchWrapper';

const onboardingService = {
  _url: `${process.env.REACT_APP_LEAD_API_URL}/onboarding`,
  _userUrl: `${process.env.REACT_APP_USER_API_URL}/onboarding`,
  _leadUrl: process.env.REACT_APP_LEAD_API_URL,

  async generateIcp(offer = {}) {
    let res = await Fetch.post(`${this._url}/generate-icp`, { offer });
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async generateMessages({ offer = {}, icp = '' } = {}) {
    let res = await Fetch.post(`${this._url}/generate-messages`, { offer, icp });
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async generateCampaignDetails({ offer = {}, icp = '' } = {}) {
    let res = await Fetch.post(`${this._url}/generate-campaign-details`, { offer, icp });
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async searchIcpLeads({ icp, start = 0, pageSize = 10, seenIds = [], region, target } = {}) {
    const body = target
      ? { icp, target, ...(region ? { region } : {}) }
      : {
          icp,
          start,
          pageSize,
          ...(seenIds.length ? { seenIds } : {}),
          ...(region ? { region } : {}),
        };
    let res = await Fetch.post(`${this._url}/icp-leads`, body);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async getOnboardingStatus() {
    let res = await Fetch.get(`${this._userUrl}/status`);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async grantOnboardingCredits() {
    let res = await Fetch.post(`${this._userUrl}/grant-credits`, {});
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async completeOnboarding() {
    let res = await Fetch.post(`${this._userUrl}/complete`, {});
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async saveWorkspaceSetup({ companyRole, useFor = [], heardAboutUs = [] } = {}) {
    let res = await Fetch.post(`${process.env.REACT_APP_USER_API_URL}/onboard-user`, {
      companyRole,
      useFor,
      heardAboutUs,
    });
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async createLead(lead) {
    let res = await Fetch.post(`${this._leadUrl}/job/create-singlelead`, lead);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async prepareEnrichment({ userLeadIds = [] } = {}) {
    let res = await Fetch.post(`${this._url}/prepare-enrichment`, { userLeadIds });
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async getConnectedLinkedinProfiles() {
    let res = await Fetch.get(`${this._leadUrl}/linkedin/get-profiles?status=all`);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },
};

export default onboardingService;
